export default "__VITE_ASSET__BX6IYg$$__"